import { EXCLUDING_THEMIS_SPAM_SAFE_OPTION } from '../constants'
import { URL_STATE_CHANGE } from '../List/constants'

import {
  CHALLENGED_TYPE_FILTER_CHANGE,
  DEFAULT_SORTING_OPTION,
  GENERAL_FILTER_CHANGE,
  getLocalStorageIncidentsSortingKey,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SORTING_FILTER_CHANGE,
  SORTING_FILTER_RESET,
} from './constants'

const initialState = {
  search: '',
  sortingBy: DEFAULT_SORTING_OPTION.unclassifiedSortingBy,
  generalFilter: EXCLUDING_THEMIS_SPAM_SAFE_OPTION.value,
  challengedTypeFilter: undefined,
}
export default function () {
  return (state = initialState, action) => {
    switch (action.type) {
      case SEARCH_RESET:
        return {
          ...state,
          search: '',
        }
      case URL_STATE_CHANGE:
        return {
          ...state,
          search: '',
          challengedTypeFilter: initialState.challengedTypeFilter,
          sortingBy:
            DEFAULT_SORTING_OPTION[getLocalStorageIncidentsSortingKey(action.payload.urlState)],
        }
      case SEARCH_CHANGE:
        return {
          ...state,
          search: action.payload.q,
        }
      case SORTING_FILTER_CHANGE:
        return { ...state, sortingBy: action.payload.value }
      case SORTING_FILTER_RESET:
        return {
          ...state,
          sortingBy: DEFAULT_SORTING_OPTION[action.payload.key],
        }
      case GENERAL_FILTER_CHANGE:
        return { ...state, generalFilter: action.payload.value }
      case CHALLENGED_TYPE_FILTER_CHANGE:
        return { ...state, challengedTypeFilter: action.payload.value }
      default:
        return state
    }
  }
}
